import { Card, CardContent, Grid, Typography } from "@mui/material";
import Link from "next/link";
import { UrlParameter } from "../../../../config/GoogleAdConfiguration";
import { NWONPage } from "../../../../config/NWONPage";
import { useDefaultDetailPageForSubServiceMap } from "../../../hooks/serviceMappings/useDefaultDetailPageForSubServiceMap";
import { useGetUrl } from "../../../hooks/urls/useGetUrl";
import { usePageInformationContext } from "../../../state/pageInformationContext/PageInformationContext";
import HtmlFromLangFile from "../../01-atoms/HtmlFromLangFile/HtmlFromLangFile";
import NWONArrow from "../../01-atoms/NWONArrow/NWONArrow";
import { NWONSubServiceCardProps } from "./NWONSubServiceCardInterfaces";
import { useNWONSubServiceCardStyles } from "./NWONSubServiceCardStyles";

const NWONSubServiceCard = (props: NWONSubServiceCardProps): JSX.Element => {
  const { subService } = props;
  const detailPageMap = useDefaultDetailPageForSubServiceMap();
  const { classes } = useNWONSubServiceCardStyles({
    hasDetailPage: !!detailPageMap[subService.subService],
  });

  const pageInformation = usePageInformationContext();
  const getUrl = useGetUrl();
  const url = getUrl({
    page: NWONPage.Services,
    mainService: pageInformation.mainService,
    subService: subService.subService,
    urlParameters: UrlParameter.CtaStyle,
  });

  const cardContent = (
    <Card className={classes.card}>
      <CardContent>
        {detailPageMap[subService.subService] ? (
          <Grid container={true}>
            <Grid item={true} xs={10} className={classes.textWrapper}>
              <Typography variant="h5" component="h3" className={classes.title}>
                <HtmlFromLangFile contentContainingHtml={subService.title} />
              </Typography>

              <Typography variant="body2">
                <HtmlFromLangFile
                  contentContainingHtml={subService.description}
                />
              </Typography>
            </Grid>

            <Grid
              item={true}
              container={true}
              xs={2}
              className={classes.arrowWrapper}
            >
              <NWONArrow />
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography variant="h5" component="h3">
              <HtmlFromLangFile contentContainingHtml={subService.title} />
            </Typography>

            <Typography variant="body2">
              <HtmlFromLangFile
                contentContainingHtml={subService.description}
              />
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );

  return detailPageMap[subService.subService] ? (
    <Link href={url} className={classes.link} passHref={true}>
      <a>{cardContent}</a>
    </Link>
  ) : (
    cardContent
  );
};

export default NWONSubServiceCard;
